import type { PropsWithChildren } from 'react';

import { useIsVisibleInViewport } from 'hooks/ui/useIsVisibleInViewport';

export const DisplayIfVisible = ({ children }: PropsWithChildren) => {
  const { handleRef, hasBeenVisible } =
    useIsVisibleInViewport<HTMLDivElement>();

  if (!hasBeenVisible) {
    return <div ref={handleRef} />;
  }
  return <>{children}</>;
};
